// extracted by mini-css-extract-plugin
export default {"formContent":"style_formContent__BAus3","saveButton":"style_saveButton__YJhy9","amountWrapper":"style_amountWrapper__cS5dk"};